/**
 * TanStack Query hooks for `cr-optimization-rule-auto-action-on-cr-below-target`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	evaluate,
	list,
	crOptimizationRuleAutoActionOnCrBelowTargetQueryKeys,
	type CreateCrRuleBody,
	type CreateCrRuleResponse,
	type EvaluateCrRuleBody,
	type EvaluateCrRuleResponse,
	type ListCrRulesResponse,
} from "./api";

export function useCrOptimizationRuleAutoActionOnCrBelowTargetList(): UseQueryResult<ListCrRulesResponse, Error> {
	return useQuery({
		queryKey: crOptimizationRuleAutoActionOnCrBelowTargetQueryKeys.list(),
		queryFn: list,
	});
}

export function useCrOptimizationRuleAutoActionOnCrBelowTargetCreate(): UseMutationResult<CreateCrRuleResponse, Error, CreateCrRuleBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: crOptimizationRuleAutoActionOnCrBelowTargetQueryKeys.all });
		},
	});
}

export function useCrOptimizationRuleAutoActionOnCrBelowTargetEvaluate(): UseMutationResult<EvaluateCrRuleResponse, Error, EvaluateCrRuleBody> {
	return useMutation({
		mutationFn: evaluate,
	});
}
